/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from "./getLikes.defs.js";
export { main as default } from "./getLikes.defs.js";
